import React, { createContext, useContext } from "react";
import { CompetitionData } from "../../components/ActiveCompetitions/types";

export const SubscriptionCompetitionsContext = createContext<{
  activeTab: "thisWeek" | "pastWinners" | "hallOfFame";
  setActiveTab: React.Dispatch<React.SetStateAction<"thisWeek" | "pastWinners" | "hallOfFame">>;
  onViewPlansClick: (utm?: string) => void;
  onDetailsClick: (competition: CompetitionData) => void;
  isAlreadySubscribed: boolean;
  lobbyContent: SubscriptionLobbyContent;
  setLobbyContent: React.Dispatch<React.SetStateAction<SubscriptionLobbyContent>>;
  isLobbyContentLoading: boolean;
  setIsLobbyContentLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  activeTab: "thisWeek",
  setActiveTab: null,
  onViewPlansClick: null,
  onDetailsClick: null,
  isAlreadySubscribed: false,
  lobbyContent: {
    pastWinnerEndDate: "",
    pastWinnerStartDate: "",
    subSubcribedHeader: {
      disclaimer: "",
      subtitle: "",
      title: "",
    },
    unsubSubcribedHeader: {
      perks: [],
      subtitle: "",
      title: "",
    },
    youveEntered: [],
    totalWinnerCount: null,
    totalPrizeCount: null,
    totalPrizeValue: null,
  },
  setLobbyContent: null,
  isLobbyContentLoading: true,
  setIsLobbyContentLoading: null,
});

export const useSubscriptionCompetitionsContext = () => useContext(SubscriptionCompetitionsContext);
